import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BrightnessFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M10.92 6.44V3.76H13.08V6.44H10.92ZM15.14 7.3L17.04 5.4L18.54 6.9L16.64 8.8L15.14 7.3ZM7.36 8.8L5.46 6.9L6.96 5.4L8.86 7.3L7.36 8.8ZM15.4 11.94C15.4 13.82 13.88 15.34 12 15.34C10.12 15.34 8.6 13.82 8.6 11.94C8.6 10.06 10.12 8.54 12 8.54C13.88 8.54 15.4 10.06 15.4 11.94ZM17.5 10.86H20.18V13.02H17.5V10.86ZM3.82 10.86H6.5V13.02H3.82V10.86ZM5.46 16.98L7.36 15.08L8.86 16.58L6.96 18.48L5.46 16.98ZM17.04 18.48L15.14 16.58L16.64 15.08L18.54 16.98L17.04 18.48ZM10.92 20.12V17.44H13.08V20.12H10.92Z" />
    </SvgIcon>
  );
});
